import React from "react";
import { useDividendsPerYear } from "../../hooks/useDividendsPerYear";
import { DividendsBaseChart } from "./DividendsBaseChart";

interface Props {
  isin?: string;
  currency?: string;
}

export const DividendsChart = ({ isin, currency }: Props) => {
  const { data: dividends, isFetching } = useDividendsPerYear(isin, currency);

  return <DividendsBaseChart dividends={dividends} isFetching={isFetching} />;
};
